<template>
    <div class="loginVue" v-loading="loading">
         <div v-if="isLocalDev" class="dev-env-banner">LOCAL DEV — {{ devHost }}</div>
         <div class="login-wrap" v-if="loginHide">
            <div class="container">
                <div class="login-center">
                    <div class="col-md-7 col-sm-12 col-xs-12">
                        <div class="containing-table">
                            <div class="col-sm-3 col-xs-12 table-cell text-center o-login-left">
                                <img v-if="domainLogo && domainLogo != '' && domainLogo != 'NULL'" :src="(domainLogo)" id='img-upload' />
                                <img v-if="!domainLogo || domainLogo == '' || domainLogo == 'NULL'" src="static/assets/images/logo.png" id='img-upload' />
                            </div>
                            <div class="col-sm-9 col-xs-12 table-cell text-left o-login-right">
                                <div class="login-page-language-selection">
                                    <div class="o-login-field mb-15">
                                        <label>{{$t('language')}}: </label>
                                        <select v-model="languageSelected" @change="onLanguageSelected()">
                                            <option v-for="(language, index) in preferedLanguages" :key="index" :value="language.value">{{ $t(language.label) }}</option>
                                        </select>
                                    </div>
                                </div>
                                <transition name="">
                                    <div v-if="tab == 'loginScreen'" class="login-screen">
                                       <form autocomplete="off">
                                        <div class="form-group">
                                            <div class="clearfix">

                                                <div class="form-group-left o-login-field">
                                                    <!-- <label>E-MAIL :</label> -->
                                                    <label>{{ $t('email') }} :</label>
                                                </div>
                                                <div class="form-group-right o-login-field">
                                                    <input autocomplete="off" @keyup.enter="validate" type="text" class="form-control u-transparent" :placeholder="$t('enter_your_email')" v-model="email" id="email" v-validate="{ required: true, email: true }" name="email">
                                                    <span v-show="errors.has('email') && this.validation_err!=0" class="err-msg">{{ errors.first('email') }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="clearfix">
                                                <div class="form-group-left o-login-field">
                                                    <label>{{ $t('password') }} :</label>
                                                </div>
                                                <div class="form-group-right o-login-field">
                                                    <input autocomplete="off" @keyup.enter="validate" type="password" class="form-control u-transparent" :placeholder="$t('enter_your_password')" v-model="password" id="pwd" v-validate="{ required: true}" name="password">
                                                    <span v-show="errors.has('password') && this.validation_err!=0" class="err-msg">{{ errors.first('password') }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">

                                            <div class="clearfix">
                                                <a href="javascript: void(0)" @click="validate()" class="c-solid-btn c-solid-btn--green o-login-btn">
                                                    {{ $t('login') }}
                                                </a>

                                                <div class="forget-float-right ps2" style="padding-bottom: 10px;">
                                                    <a href="javascript: void(0)" @click="goToForget()" class="o-forget-password font-red">
                                                        <!-- GET NEW PASSWORD? -->
                                                        {{ $t('forgot_password') }}
                                                        </a>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="form-group">
                                            <div class="clearfix signin_options">
                                                <a href="javascript: void(0)" v-google-signin-button="clientId" class="sign-in-google">
                                                    <div class="image-block">
                                                        <img src="static/assets/images/Google-512.webp" width="20px" />
                                                    </div>
                                                    <div class="button-font">
                                                        <span>
                                                        Sign in  with Google
                                                        </span>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>

                                        <!-- #1848 / #1849 — Apple sign-in runs ONLY on the login
                                             host for this TLD, the one address registered with
                                             Apple. This used to render everywhere and dead-end on
                                             Apple's "Invalid web redirect url" page for every
                                             tenant subdomain and for all of login.callsteward.ca.

                                             The flow is a POPUP (usePopup -> response_mode
                                             web_message) and Apple posts the answer back to the
                                             redirect_uri's origin, so simply pointing a subdomain
                                             at the login host would hang instead of erroring —
                                             worse. The sign-in has to run there, so we take the
                                             member there. -->
                                        <vue-apple-login
                                            v-if="appleRunsHere"
                                            mode="center-align"
                                            type="sign in"
                                            color="white"
                                            :border="true"
                                            :radius="20"
                                            width="200"
                                            height="36"
                                            logoSize="large"
                                            :logoPosition="0"
                                            :labelPosition="0"
                                            className="vue-apple-login"
                                            response_mode="web_message"
                                            :onSuccess="onAppleAuthSuccess"
                                            :onFailure="onAppleAuthFail"
                                        ></vue-apple-login>

                                        <!-- Not the login host: same affordance, but it carries the
                                             member to a host where Apple will actually answer,
                                             instead of showing a control that cannot work. -->
                                        <a
                                            v-else-if="appleSignInUrl"
                                            :href="appleSignInUrl"
                                            class="vue-apple-login apple-signin-elsewhere"
                                        >
                                            <i class="fa fa-apple" aria-hidden="true"></i>
                                            <span>{{ $t('Sign in with Apple') }}</span>
                                        </a>

                                        <div class="o-error-msg" v-if="credential_err.length && credential_err=='Invalid login credentials! please visit the faq at https://cs3.m3/ilc'">
                                            <div class="error-note">
                                                <span class="error-message1">{{ $t('invalid_login_credentials') }}</span>
                                                <span>{{ $t('please_visit_faq') }}</span>
                                                <br />
                                                <a href="https://cs3.me/ilc" class="text-white1" target="_blank"> Faq-Invalid Login Credentials </a>
                                            </div>
                                        </div>
                                        <div class="o-error-msg" v-else-if="credential_err.length">
                                            <div class="error-note">
                                                <span>{{ credential_err }}</span>
                                                <!-- <span>{{ $t('invalid_login_credentials') }}</span>
                                                <span>{{ $t('please_visit_faq') }}</span> -->
                                                <!-- <br /> -->
                                                <!-- <a href="https://cs3.me/ilc" class="text-white1" target="_blank"> Faq-Invalid Login Credentials </a> -->
                                            </div>
                                        </div>
                                    </form>
                                   </div>
                                </transition>
                                <transition name="">
                                    <div v-if="tab == 'forgetScreen'" class="forget-screen">
                                        <form>
                                            <div class="form-group">
                                                <div class="clearfix">
                                                    <div class="form-group-left o-login-field">
                                                        <!-- <label>E-MAIL :</label> -->
                                                        <label>{{ $t('email') }} :</label>
                                                    </div>
                                                    <div class="form-group-right o-login-field">
                                                        <input @keyup="passwordReset" type="email" class="form-control u-transparent" :placeholder="$t('enter_your_email')" v-model="resetemail" id="resetemail" v-validate="{ required: true, email: true }" name="resetemail">
                                                        <span v-show="errors.has('resetemail') && this.validation_err!=0" class="err-msg">{{ errors.first('resetemail') }}</span>
                                                        <div class="text-right ps2">
                                                            <a href="javascript: void(0)" @click="goToLogin()" class="o-forget-password">
                                                                <!-- Log in? -->
                                                                {{ $t('login') }}?
                                                                </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <div class="clearfix">
                                                    <a href="javascript: void(0)" @click="getResetLink()" class="c-solid-btn c-solid-btn--green o-login-btn">
                                                        <!-- Get Reset Link -->
                                                        {{ $t('get_reset_link') }}
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="o-error-msg">
                                                <span :class="resetInfo_err.length?'error-note':''" v-if="resetInfo_err.length">{{this.resetInfo_err}}</span>
                                            </div>
                                        </form>
                                    </div>
                                </transition>
                                <transition name="">
                                    <div v-if="tab == 'successPassword'" class="successPassword-screen">

                                        <div class="login-success-note">
                                          <!-- <h1>Thank you</h1>thank_you -->
                                          <!-- <h3>Your reset link has been sent to your registerd email address</h3> -->
                                          <h1>{{ $t('thank_you') }}</h1>
                                          <h3>{{ $t('reset_link_email_message') }}</h3>
                                        </div>
                                        <div class="">
                                            <div class="clearfix">
                                                <div class="text-center ps2">
                                                    <a href="javascript: void(0)" @click="goToLogin()" class="o-forget-password"><i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                                    <!-- Go To Login -->
                                                    {{ $t('go_to_login') }}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </transition>
                            </div>
                        </div>

                        <!-- <p class="ps2 text-center u-margin-20">After logging in for the first time, please change your password, and user name if desired. Verify all personal information, and assign your skills.</p> -->
                        <!-- <a href="javascript: void(0)" class="ps2 text-center display-block">Privacy policy</a> -->
                        <p class="ps2 text-center u-margin-20">{{ $t('login_page_verify_text') }}</p>
                        <a href="javascript: void(0)" class="ps2 text-center display-block">{{ $t('privacy_policy') }}</a>
                    </div>
                    <!-- <div class="col-md-5 col-sm-12 col-xs-12">
                        <div class="containing-table">
                            <div class="col-sm-3 col-xs-12 table-cell text-center o-login-left login-left-spacing">
                                <img v-if="login_image && login_image != '' && login_image != 'NULL'" :src="login_image" width="100"/>
                                <img v-if="!login_image || login_image == '' || login_image == 'NULL'" src="static/assets/images/logo.png" width="100" />
                            </div>
                            <div class="col-sm-9 col-xs-12 table-cell text-left o-login-right login-right-spacing">
                                <transition name="">
                                    <div class="login-screen login-right-screen">
                                        <p v-html="login_text"></p>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
        </div>

      </div>
</template>
<script>
    import service from '../services';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import { global } from '../global.js';
    import { getAppleSignInHost, appleSignInRunsHere } from '../global.js';   // #1849 / #1848
    import GoogleSignInButton from 'vue-google-signin-button-directive';
    import { initializeProactiveRefresh, clearRefreshTimer } from '../api';
    import { registerFcmToken, setupForegroundMessageHandler, getNotificationPermissionState } from '../utils/firebase-messaging';
    import { sanitize } from '../safeHtmlRules.js';   // #2036

    export default {
        computed: {
            ...mapGetters({
                userID: 'userID',
                employeeId: 'employeeId',
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                getBrowserSettingsLanguage: 'getBrowserSettingsLanguage',
                userLanguage: 'userLanguage'
            }),
            /**
             * #1848 / #1849 — can Apple sign-in actually complete on THIS host?
             *
             * True only on the login host for this TLD, which is the one address
             * registered with Apple (see getAppleSignInHost). Everywhere else the
             * button used to render and dead-end on Apple's error page:
             *
             *     {"errorMessage":"Invalid web redirect url.","errorCode":"invalid_request"}
             *
             * Measured on the fifteen locals with their own ALB host rule -- the
             * largest ones, Local 2 included -- plus every member on
             * `login.callsteward.ca`. The button was confirmed VISIBLE in a real
             * browser on iatse2, iatse134 and cs3demo, so this was a visible dead
             * end for most of the membership, not a theoretical one.
             */
            appleRunsHere() {
                return appleSignInRunsHere();
            },
            /**
             * #1848 -- where to send someone who asked for Apple sign-in on a host
             * that cannot serve it. Null on a host with no login address, and the
             * template then offers nothing rather than a broken link.
             *
             * They land on the login host and sign in there. That is not a
             * downgrade: a member who starts at `login.` stays there through
             * client selection anyway (verified end-to-end -- login ->
             * #/switchClient -> #/privacy-policy-review -> /schedule, host
             * unchanged), so the subdomains are ENTRY points, not destinations.
             */
            appleSignInUrl() {
                var host = getAppleSignInHost();

                return host ? 'https://' + host + '/#/login' : null;
            },
            isLocalDev() {
                var p = window.location.port;
                return p === '8080' || p === '8443';
            },
            devHost() {
                return window.location.host;
            },
            deviceDetector() {
                let userAgent = navigator.userAgent.toLowerCase();
                const check =(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop");

                return("desktop" != check ? !0 : !1);

            },
        },
        data() {
            return {
                preferedLanguages: [
                    {
                        label: 'english',
                        value: 'en'
                    },
                    {
                        label: 'spanish',
                        value: 'es'
                    },
                    {
                        label: 'french',
                        value: 'fr'
                    }
                ],
                languageSelected: '',
                loginHide:true,
                email: "",
                password: "",
                validation_err: 0,
                credential_err: "",
                tab: 'loginScreen',
                resetemail: '',
                resetInfo_err: '',
                redirect_link: '',
                domainLogo: '',
                getBaseURL: '',
                getClientBase: '',
                login_image:'',
                login_text:'',
                clientdata:null,
                loading:false,
                clientId: "508718336686-s1b3dg4trrs2fk287qsegbregbthkiuu.apps.googleusercontent.com"
            }
        },
        directives: {
            GoogleSignInButton
        },
        watch: {
            email: function() {
                this.credential_err = "";
            },
            password: function() {
                this.credential_err = "";
            }
        },
        methods: {
            onLanguageSelected() {
                localStorage.setItem("lang", this.languageSelected);
                this.$store.dispatch('saveBrowserSettingsLanguage', this.languageSelected);
                location.reload();
            },

            connectWithGoogle() {
                this.$Progress.start();
                service.get('auth/authorizeRequest', { url: window.location.href })
                    .then((res) => {
                        let path = res.data.result.dataSet;
                        this.$Progress.finish();
                        window.location.href = path;
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.fail();
                        this.credential_err = this.$t('something_went_wrong');
                    });
            },

            loginWithGoogle(idToken) {
                this.$Progress.start();
                service
                .post('auth/socialLogin', {
                    url: window.location.href,
                    idToken: idToken
                })
                .then(async (res) => {
                    await this.getIntoApp(res);
                })
                .catch((err) => {
                    this.$Progress.fail();
                    this.credential_err = this.$t('something_went_wrong');
                });
            },

            loginWithApple(appleResponse) {
                this.$Progress.start();
                service
                .post('auth/appleLogin', {
                    idToken: appleResponse.authorization.id_token,
                    url: window.location.href
                })
                .then(async (res) => {
                    await this.getIntoApp(res);

                }).catch((err) => {
                    this.$Progress.fail();
                    this.credential_err = this.$t('something_went_wrong');
                });
            },

            passwordReset() {
                this.resetInfo_err = "";
            },

            getResetLink() {
                this.$Progress.start();
                this.redirect_link = window.location.href.split('#')[0];
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.validation_err = 0;
                        service.post('auth/forgotPassword', {
                            redirect_link: this.redirect_link,
                            email: this.resetemail,
                        }, {}).then((res) => {
                            if (res.data.result.status == 0) {
                                this.$Progress.fail();
                                this.resetInfo_err = res.data.result.message;
                            } else {
                                this.tab = "successPassword";
                                this.resetInfo_err = "";
                                this.$Progress.finish();
                            }

                        }).catch((err) => {
                            this.$Progress.fail();
                            this.resetInfo_err = this.$t('something_went_wrong');
                        });

                    } else {
                        this.validation_err = 1;
                    }
                });
            },

            goToForget() {
                this.tab = "forgetScreen";
                this.resetemail = "";
            },

            goToLogin() {
                this.tab = "loginScreen";
                this.email = "";
                this.password = "";
            },

            validate: function() {
                this.$Progress.start();
                this.$validator
                .validateAll()
                .then((result) => {
                    if (result) {
                        this.validation_err = 0;
                        this.loading = true;
                        service
                        .post('auth/login', {
                            email: this.email,
                            password: this.password,
                            url: window.location.href,
                            language: this.languageSelected
                        })
                        .then(async (res) => {
                            await this.getIntoApp(res);
                        })
                        .catch((err) => {
                            this.$Progress.fail();
                            this.loading=false;
                            this.credential_err = this.$t('something_went_wrong');
                        });
                    } else {
                        this.loading = false;
                        this.validation_err = 1;
                    }
                });
            },

            async domainIdentify() {
                this.loading=true;
                await service.get('auth/domain', {
                        'url': document.location.href.split('#')[0] + "#/login",
                    })
                    .then((res) => {
                        this.domainLogo = (res.data.result) ? res.data.result.logo : null;
                        this.clientdata=(res.data.result) ? res.data.result : null;
                        this.login_image=this.clientdata ? this.clientdata.login_image : '';
                        var rawMsg = this.clientdata ? this.clientdata.login_page_message : '';
                        // #2036 — sanitize, do not decorate. This line used to be
                        //   rawMsg.replace(/<a /g, '<a target="_blank" rel="noopener" ')
                        // which ADDS an attribute and removes nothing, on a value rendered with v-html on
                        // a page served to anyone who opens it. Every row written before #2036 is
                        // unvalidated, so the display path — not the save path — is what disarms them.
                        // target/rel are forced by the sanitizer's own hook now.
                        this.login_text = sanitize(rawMsg);
                        this.loading=false;
                        // if(res.data.result==null && document.location.href.split('#')[0] != 'http://localhost:8080/' && document.location.href.split('#')[0] != 'https://labour.' + global[0].CLIENT_BASE) {
                        //     this.$router.push({
                        //         path: "/pageNotFound"
                        //     });
                        // }

                    }).catch((err) => {
                        this.loading=false;
                        this.$Progress.fail();
                    });
            },

            cleanCookiesData() {
                this.$cookies.remove("csLogin", "/mobile");
                this.$cookies.remove("csLogin");
                this.$cookies.remove("date_format");
                this.$cookies.remove("time_format");
                this.$cookies.remove("time_zone");
                localStorage.removeItem('vuex');
                this.$store.dispatch('setTokenExpiry', '');
                localStorage.clear();
            },

            OnGoogleAuthSuccess (idToken) {
                this.loginWithGoogle(idToken); // Receive the idToken and make your magic with the backend
            },

            OnGoogleAuthFail (err) {
                this.$notify.error({
                    title: 'Error',
                    message: err.error
                })
            },

            onAppleAuthSuccess(res) {
                this.loginWithApple(res);
            },

            onAppleAuthFail(err) {
                this.$notify.error({
                    title: 'Error',
                    message: err.detail.error
                })
            },

            async getIntoApp(res) {
                localStorage.removeItem('vuex');
                if (res.data.status_code == 0) {
                    this.$Progress.fail();
                    this.loading = false;
                    this.credential_err = res.data.status_message;
                } else {
                    let data = res.data.result;
                    this.$store.dispatch('setTokenExpiry', data.token_expiry);

                    this.$store.dispatch('userSession', data); //set user data with token in store
                    this.$store.dispatch('setLoginSuper', false);
                    initializeProactiveRefresh();

                    // Register browser push notification token if permission already granted
                    if (getNotificationPermissionState() === 'granted') {
                        registerFcmToken(data.token, '').catch(function (e) { console.error('[FCM] post-login register error:', e); });
                        setupForegroundMessageHandler(this);
                    }

                    this.$cookies.set("csLogin", data.role.slug, "23h");
                    this.$cookies.set("csLogin", data.role.slug, "23h",'/mobile');
                    this.credential_err = "";
                    this.$Progress.finish();
                    $('.wrapper').css('margin-left', '60px');
                    if (data.role.slug == "client-admin" || data.role.slug == "employee" || data.role.slug == "power-user" || data.role.slug == "power-user-minus" || data.role.slug == "auditor") {
                        if(data.user && data.user.employees && data.user.employees.length && data.user.employees[0].client_employee && data.user.employees[0].client_employee.clients){
                            this.$cookies.set("time_zone", data.user.employees[0].client_employee.clients.timezone, "23h");
                            this.$cookies.set("date_format", data.user.employees[0].date_format, "23h");
                            this.$cookies.set("time_format", data.user.employees[0].time_format, "23h");
                            this.$cookies.set("powerSteward", data.user.employees[0].client_employee.clients.power_steward, "23h");
                            var notifyType = (data.user.employees[0].email_notification == 1) ? 'email' : 'sms';

                            this.$store.dispatch('setNotificationType', notifyType);
                            this.$store.dispatch('setClientdata', data.user.employees[0].client_employee.clients);
                        }
                        if (data.role.slug == "client-admin" || data.role.slug == "power-user" || data.role.slug == "power-user-minus") {
                            this.$store.dispatch('setLastOpenJob', 0);
                            if(data.role.slug == "power-user" || data.role.slug == "power-user-minus"){
                                this.$router.push({
                                    path: "/switchClient"
                                });
                            }
                            else{
                                // Check for pending privacy policies before going to jobList
                                this.checkPoliciesThenNavigate('/jobList');
                            }
                        } else {
                            if(document.getElementsByTagName('body')[0].clientWidth < 700)
                            {
                                this.$cookies.set("csLogin", data.role.slug, "23h",'/mobile');
                                this.$cookies.set("date_format", data.user.employees[0].date_format, "23h", '/mobile');
                                this.$cookies.set("time_format", data.user.employees[0].time_format, "23h", '/mobile');
                                window.location.href = window.location.href.split('#')[0]+"mobile/";
                            } else{
                                this.$router.push({
                                    path: "/switchClient"
                                });
                            }
                        }

                    } else if(data.role.slug == "employer-admin" || data.role.slug == "employer"){

                        // #1712 — do NOT force a page reload here.
                        //
                        // This branch used to call window.location.reload(true) before
                        // routing (added 2022, 2daacdf91). The symptom was an employer
                        // login that "flashes into the app and returns to the login
                        // screen":
                        //
                        //   1. the csLogin cookie + vuex session are set just above
                        //   2. the router reaches /employerJobList  <- the flash
                        //   3. the forced reload tears the page down mid-flight
                        //   4. on reboot the token is not in place yet, so the first
                        //      API call 401s; the refresh fails; and the hard-logout
                        //      path in api.js clears localStorage AND every cookie and
                        //      sends the browser back to #/login
                        //
                        // No other role reloads here -- client-admin, employee,
                        // power-user and super-admin all just router.push -- and they
                        // do not exhibit this. The reload is the whole bug.
                        this.$router.push({
                            path: "/employerJobList"
                        });

                    } else if(data.role.slug == "super-admin") {
                        this.$router.push({
                            path: "/clientList"
                        });
                    }
                }
                this.loading=false;
            },

            checkPoliciesThenNavigate(destination) {
                var self = this;
                var empId = self.$store.getters.employeeId;
                var clientId = self.$store.getters.userClientID;
                service.get('employee/pendingPrivacyPolicies', {
                    'Authorization': self.$store.getters.userToken,
                    'cs3-context-clientId': clientId,
                    'cs3-context-employeeId': empId,
                    'cs3-context-role': self.$store.getters.userRole
                }).then(function (res) {
                    var pending = res.data.result || [];
                    if (pending.length > 0) {
                        self.$router.push({
                            path: '/privacy-policy-review',
                            query: { redirect: destination }
                        });
                    } else {
                        self.$router.push({ path: destination });
                    }
                }).catch(function () {
                    self.$router.push({ path: destination });
                });
            },

            updateViewport(isMobile) {
                // Login page is always responsive — use device width so it
                // renders properly on phones (Galaxy S6 = 360px viewport).
                // Other pages still force width=1024 for the desktop app layout.
                const content = 'width=device-width, initial-scale=1.0, maximum-scale=1, user-scalable=no';

                const existing = document.querySelector('meta[name="viewport"]');

                const newMeta = document.createElement('meta');
                newMeta.name = 'viewport';
                newMeta.content = content;

                if (existing) {
                    existing.parentNode.replaceChild(newMeta, existing);
                } else {
                    document.head.appendChild(newMeta);
                }
            }
        },

        mounted() {
            clearRefreshTimer();
            if(this.userLanguage && this.userLanguage != '')
                this.languageSelected = this.userLanguage;
            else {
                if(localStorage.getItem("lang") && localStorage.getItem("lang") != '')
                    this.languageSelected = localStorage.getItem("lang");
                else this.languageSelected = 'en'
            }
            localStorage.setItem("lang", this.languageSelected);
            this.$store.dispatch('saveBrowserSettingsLanguage', localStorage.getItem("lang"));
            //alert('created');
            $('.loginVue').parent('.wrapper').css('margin-left', '0');
            this.cleanCookiesData();

            const isMobile = this.deviceDetector;
            this.updateViewport(isMobile);

        },
        beforeMount() {
            this.getBaseURL = global[0].IMAGE_URL;
            this.getClientBase = global[0].CLIENT_BASE;
            let winLocHref = window.location.hostname;
            let dummy = '.' + this.getClientBase
            let split1 = document.location.href.split(dummy)[0]
            let sub_domain = split1.split('//')[1]

            // if((winLocHref != 'localhost')&&(sub_domain != 'labour')&&(sub_domain != 'login')&&(sub_domain != 'admin')) {
            //     window.location.href = 'https://login.'+this.getClientBase+"#/login";
            // }

            let lang = localStorage.getItem("lang");
            if (lang && lang != '') {
                localStorage.setItem("lang", lang);
            } else {
                let locLang = (navigator.language || navigator.userLanguage).split('-')[0];
                if (locLang && locLang == 'es') {
                    lang = 'es';
                } else if(locLang && locLang == 'fr') {
                    lang = 'fr';
                } else {
                    lang = 'en';
                }
                localStorage.setItem("lang", lang);
            }
            this.$store.dispatch('saveBrowserSettingsLanguage', localStorage.getItem("lang"));
        },

        created() {

            this.domainIdentify();
        }
    }

</script>
<style scoped>
    .dev-env-banner {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 9999;
        background: #ff6600;
        color: #fff;
        text-align: center;
        padding: 6px 0;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 1px;
        text-transform: uppercase;
        box-shadow: 0 2px 4px rgba(0,0,0,0.3);
    }
    .text-white1{
    color: #ffffff;
  }
    .forget-float-right {
        float: right;
        font-weight: 600;
    }

    .font-red {
        color: #fe1f1f;
    }

    .signin_options {}

    .login-center {
        left: 60%;
    }

    .signin_options .sign-in-google {
      display: flex;
      flex-direction: row;
      justify-items: center;
      width: 200px;
      height: 36px;
      border-radius: 2px;
      padding: 1px;
      background-color: #4285F4;
  }

  .signin_options .sign-in-google .image-block {
    height: 34px;
    width: 34px;
    background-color: #ffffff;
    text-align: center;
    vertical-align: middle;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 5px;
  }

  .signin_options .sign-in-google .image-block img {
      background-color: #FFFFFF;
      height: 24px;
      width: 24px!important;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
  }

  .signin_options .sign-in-google .button-font{
      margin-top: 8px;
  }

  .signin_options .sign-in-google .button-font span {
    color: #FFFFFF;
    font-size: 16px;
    vertical-align: middle;
    padding: 10px;
    font-weight: 500;
    font-family: 'Roboto', 'Helvetica';
  }

    #page {
        visibility: visible !important;
    }

    .loginVue {
        min-height: 200px;
    }

    .mb-15 {
        margin-bottom: 15px;
    }
    .fade-enter {
        opacity: 0
    }

    .fade-enter-active {
        transition: opacity .40s ease
    }

    .fade-leave {}

    .fade-leave-active {
        transition: opacity .40s ease;
        opacity: 0
    }

    button.login-button {
      background-color: white;
      height: 36px;
      width: 200px;
      border-radius: 5px;
      border: 2px;
      font-size: 12px;
      font-weight: 500;
      margin: 5px;
    }
    button.login-button svg{
      height: 30px;
      margin-top: -3px;
      margin-right: 3px;
    }

    /* ── Mobile responsive (Galaxy S6 = 360px, up to 480px) ── */
    @media (max-width: 768px) {
        .login-center {
            position: relative !important;
            top: auto !important;
            left: auto !important;
            transform: none !important;
            width: 100% !important;
            padding: 20px 0;
        }
    }

    @media (max-width: 480px) {
        .loginVue >>> .containing-table {
            display: flex;
            flex-direction: column;
        }
        .loginVue >>> .containing-table .table-cell {
            display: block;
            width: 100% !important;
            float: none;
        }
        .loginVue >>> .o-login-left {
            padding: 15px 10px;
            text-align: center;
        }
        .loginVue >>> .o-login-left img {
            width: 70px;
        }
        .loginVue >>> .o-login-right {
            padding: 15px 15px 25px;
        }
        .loginVue >>> .o-login-btn {
            width: 100%;
            display: block;
            text-align: center;
            padding: 12px 20px;
            font-size: 16px;
        }
        .loginVue >>> .o-login-field label {
            font-size: 13px;
        }
        .loginVue >>> .o-login-field input {
            font-size: 16px;
            padding: 8px 5px;
        }
        .loginVue >>> .login-page-language-selection select {
            font-size: 14px;
            padding: 4px;
        }
        .loginVue >>> .signin_options .sign-in-google {
            width: 100%;
        }
        .loginVue >>> .vue-apple-login {
            width: 100% !important;
        }
        /* #1848 — the off-login-host Apple affordance. The SDK renders its own
           button and we cannot reuse it here (it is exactly what does not work on
           this host), so this matches Apple's shape: white, thin border, rounded
           to the same radius the component is configured with. */
        .apple-signin-elsewhere {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            height: 36px;
            width: 200px;
            margin: 0 auto;
            background: #fff;
            color: #000;
            border: 1px solid #000;
            border-radius: 20px;
            font-size: 14px;
            line-height: 1;
            text-decoration: none;
        }
        .apple-signin-elsewhere:hover,
        .apple-signin-elsewhere:focus {
            color: #000;
            text-decoration: none;
            opacity: 0.85;
        }
        .apple-signin-elsewhere .fa-apple {
            font-size: 18px;
        }
        .loginVue >>> .o-error-msg {
            font-size: 13px;
            word-break: break-word;
        }
        .loginVue >>> .login-success-note h1 {
            font-size: 22px;
        }
        .loginVue >>> .login-success-note h3 {
            font-size: 14px;
        }
    }
</style>
